<ng-container *ngIf="audioList.length > 0">
  <div class="container">
    <div class="content">
      <span>{{ 'MARRIOTT.AUDIO_1' | translate }}</span>
      <img class="audio-icon" src="assets/images/icons/audio-icon_RC-RUWIDO.png" alt="" />
      <span>{{ 'MARRIOTT.AUDIO_2' | translate }}</span>
      <div class="audio-list">
        <ng-container *ngFor="let item of audioList; index as i; let last = last">
          <span
            class="htv-selectable htv-force-direction"
            [class.selected-audio]="i === currentIndex"
            (click)="selectTrack(item)"
            [innerText]="item.label"></span>
          <span *ngIf="!last">, </span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
